import React, { useState } from 'react';

// Grid size configs logic
export default function ControlPanel({ isAdminMode, onResetColors, onResetGame, connected, gridRadius, onChangeGridSize, mode, socket, roomId }) {
  const [newPin, setNewPin] = useState(null);

  const handleResetPin = () => {
    if (window.confirm('هل أنت متأكد من تغيير الرقم السري؟ سيتم إنشاء رقم جديد للمدير.')) {
      socket.emit('reset_pin', (res) => {
        if (res && res.success) {
          setNewPin(res.pin);
          localStorage.setItem(`pin_${roomId}`, res.pin);
        }
      });
    }
  };
  const currentSizes = (mode === '2p' || mode === '4p')
    ? [ { radius: 5, label: '٥ × ٥ سداسي' }, { radius: 6, label: '٦ × ٦ سداسي' } ]
    : [ { radius: 2, label: '١٩ سداسي' },    { radius: 3, label: '٣٧ سداسي' }, { radius: 4, label: '٦١ سداسي' } ];
  return (
    <div className="control-panel">
      <h3>⚙️ لوحة التحكم</h3>

      <div className="mode-indicator" style={{ marginBottom: 12 }}>
        الوضع الحالي:{' '}
        <strong>مدير الجلسة 👑</strong>
      </div>

      {isAdminMode && (
        <>
          <div style={{
            fontSize: '0.78rem',
            color: 'var(--text-muted)',
            background: 'rgba(255,255,255,0.04)',
            borderRadius: 8,
            padding: '8px 10px',
            lineHeight: 1.7,
            marginTop: 8
          }}>
            💡 انقر على أي خلية لتلوينها باختيار الفريق المناسب.
          </div>

          <div style={{ marginTop: 12 }}>
            <div style={{ fontSize: '0.85rem', color: 'var(--text)', marginBottom: 6, fontWeight: 'bold' }}>تغيير عدد الخانات (حجم الشبكة):</div>
            <div style={{ display: 'flex', gap: '8px' }}>
              {currentSizes.map(gs => (
                <button
                  key={gs.radius}
                  className={`btn ${gridRadius === gs.radius ? 'btn-mode active' : 'btn-reset-colors'}`}
                  style={{ flex: 1, padding: '8px', fontSize: '0.8rem' }}
                  onClick={() => onChangeGridSize(gs.radius)}
                  disabled={!connected || gridRadius === gs.radius}
                >
                  ⬡ {gs.label}
                </button>
              ))}
            </div>
          </div>
        </>
      )}

      <div style={{ display: 'flex', gap: '8px', marginTop: '12px', flexWrap: 'wrap' }}>
        <button
          className="btn btn-warning"
          onClick={() => {
            if (window.confirm('هل أنت متأكد من مسح الألوان الفقط (مع بقاء الحروف)؟')) onResetColors(false);
          }}
          disabled={!connected}
          title="مسح ألوان الفريقين فقط مع إبقاء نفس الحروف"
        >
          🧹 تصفير الألوان فقط
        </button>
        <button
          className="btn btn-danger"
          onClick={() => {
            if (window.confirm('هل أنت متأكد من مسح الألوان وتكوين حروف جديدة عشوائية؟')) onResetColors(true);
          }}
          disabled={!connected}
          title="مسح ألوان الفريقين وتكوين حروف جديدة"
        >
          🔀 تصفير وخلط الحروف
        </button>
        <button
          className="btn btn-reset-game"
          onClick={onResetGame}
          disabled={!connected}
          title="إعادة توزيع الحروف عشوائياً وتصفير كل شيء"
        >
          🔄 إعادة شاملة
        </button>
      </div>

      <div style={{
        marginTop: 4,
        fontSize: '0.75rem',
        color: connected ? '#66bb6a' : '#ef5350',
        textAlign: 'center',
        fontWeight: 600,
      }}>
        {connected ? '● متصل بالخادم' : '● غير متصل'}
      </div>

      <div style={{
        marginTop: 8,
        padding: '10px',
        background: 'rgba(0,0,0,0.2)',
        borderRadius: 8,
        fontSize: '0.75rem',
        color: 'var(--text-muted)',
        lineHeight: 1.8,
      }}>
        <div style={{ fontWeight: 700, marginBottom: 4, color: 'var(--text)' }}>أهداف الفرق:</div>
        <div style={{ color: '#FFB347' }}>🟠 برتقالي: أعلى ↔ أسفل</div>
        <div style={{ color: '#3CB371' }}>🟢 أخضر: {mode === '2p' || mode === '4p' ? 'يسار ↔ يمين' : 'يمين علوي ↔ يسار سفلي'}</div>
        {mode !== '2p' && <div style={{ color: '#1E88E5' }}>🔵 أزرق: {mode === '4p' ? 'يمين ↔ يسار' : 'يسار علوي ↔ يمين سفلي'}</div>}
        {mode === '4p' && <div style={{ color: '#D4A3FF' }}>🟣 بنفسجي: أسفل ↔ أعلى</div>}
      </div>

      {isAdminMode && (
        <div style={{ display: 'flex', gap: '8px', marginTop: '12px', background: 'rgba(255,0,0,0.1)', padding: '10px', borderRadius: 8, alignItems: 'center' }}>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '0.75rem', color: '#ffaaaa', marginBottom: 2 }}>الرقم السري الحالي:</div>
            <div style={{ fontSize: '1.2rem', fontWeight: 'bold', letterSpacing: 4, color: '#fff' }}>{newPin || '****'}</div>
          </div>
          <button className="btn" style={{ background: '#ff5252', color: '#fff', fontSize: '0.8rem', padding: '8px 12px' }} onClick={handleResetPin} disabled={!connected}>
            تغيير الرقم
          </button>
        </div>
      )}

      {isAdminMode && (
        <div style={{ marginTop: '12px', background: 'rgba(0,128,255,0.1)', padding: '15px', borderRadius: 8, textAlign: 'center' }}>
          <div style={{ fontWeight: 'bold', marginBottom: 5, color: '#1E88E5' }}>رابط المتسابقين (زر السرعة) 🚨</div>
          <p style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginBottom: 10 }}>امسح الباركود أسفله لتمكين الفرق من استخدام زر السرعة (Buzzer)</p>
          <img 
            src={`https://quickchart.io/qr?text=${encodeURIComponent(window.location.origin + '/?room=' + roomId + '&buzzer=true')}&size=150&margin=1`} 
            alt="Player QR Code" 
            onError={e => {
              if (!e.target.dataset.retry) {
                e.target.dataset.retry = '1';
                e.target.src = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(window.location.origin + '/?room=' + roomId + '&buzzer=true')}`;
              }
            }}
            style={{ width: 120, height: 120, borderRadius: 8, margin: '0 auto', display: 'block', background: '#fff', padding: 4 }}
          />
          <div style={{ fontSize: '0.8rem', color: '#1E88E5', marginTop: 10, cursor: 'pointer', textDecoration: 'underline' }} onClick={() => {
              navigator.clipboard.writeText(window.location.origin + '/?room=' + roomId + '&buzzer=true');
              alert('تم نسخ رابط المتسابقين السري!');
          }}>
            📋 نسخ الرابط للمشاركة
          </div>
        </div>
      )}
    </div>
  );
}
